import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/content";
import { goToEstimate } from "@/lib/scroll";
import { Eyebrow, Reveal } from "./Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#10151F] py-24 lg:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal><Eyebrow>Services</Eyebrow></Reveal>
        <Reveal delay={0.1}><h2 className="mt-5 font-display text-4xl leading-[1.05] text-[#F5F0E6] sm:text-5xl lg:text-6xl">Every surface, <span className="italic text-[#CDA85B]">every room.</span></h2></Reveal>
        <Reveal delay={0.2}><p className="mt-6 max-w-xl text-[#C4C1B9]">Projects of all sizes, from a single bathroom vanity to whole-home and commercial builds.</p></Reveal>
      </div>

      <div className="mt-14 grid gap-px overflow-hidden border border-white/[0.07] bg-white/[0.07] sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={(i % 3) * 0.08} className="h-full">
            <button
              onClick={() => goToEstimate({ project_type: s.title.includes("Vanit") ? "Bathroom vanity" : s.title.includes("Restoration") ? "Countertop restoration" : s.title.includes("Fireplace") ? "Fireplace surround" : s.title.includes("Bars") ? "Island / bar" : "Kitchen countertops" })}
              data-testid={`service-card-${s.n}`}
              className="group relative flex h-full min-h-[300px] w-full flex-col justify-between overflow-hidden bg-[#10151F] p-8 text-left"
            >
              <img src={s.img} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-25" />
              <span className="relative flex items-center justify-between">
                <span className="font-display text-sm text-[#CDA85B]">{s.n}</span>
                <ArrowRight className="h-5 w-5 -translate-x-2 text-[#CDA85B] opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-x-0 group-hover:opacity-100" />
              </span>
              <span className="relative">
                <span className="block font-display text-3xl leading-tight text-[#F5F0E6]">{s.title}</span>
                <span className="mt-3 block text-sm leading-relaxed text-[#C4C1B9]">{s.text}</span>
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
